import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PS } from '../theme';
import { Icon } from '../lib/icons';
import Screen from '../components/Screen';
import { ARTICLES, HIGHLIGHTS } from '../data/knowledge';

const HL_TONE = {
  ink: { bg: PS.ink, fg: '#f5f1ea', tag: 'rgba(245,241,234,0.6)' },
  terra: { bg: 'oklch(0.62 0.12 38)', fg: '#fff', tag: 'rgba(255,255,255,0.7)' },
  green: { bg: 'oklch(0.42 0.07 155)', fg: '#fff', tag: 'rgba(255,255,255,0.7)' },
  danger: { bg: 'oklch(0.46 0.13 28)', fg: '#fff', tag: 'rgba(255,255,255,0.7)' },
};

export default function Learn() {
  const nav = useNavigate();
  return (
    <Screen bg={PS.page}>
      <div style={{ padding: '14px 16px 12px', display: 'flex', alignItems: 'center', gap: 12, flexShrink: 0 }}>
        <button data-testid="learn-back-btn" onClick={() => nav('/app')} className="ps-press" style={{ border: 'none', background: 'transparent', padding: 0 }}><Icon.chevronL size={20} stroke={PS.ink} /></button>
        <div>
          <div style={{ fontSize: 10.5, color: PS.textMuted, letterSpacing: 1, textTransform: 'uppercase' }}>ฐานความรู้</div>
          <div style={{ fontSize: 20, fontWeight: 600, letterSpacing: -0.3 }}>คู่มือเล่นแชร์ปลอดภัย</div>
        </div>
      </div>

      <div style={{ flex: 1, overflow: 'auto', paddingBottom: 30 }}>
        <div style={{ padding: '0 20px 8px', fontSize: 13, color: PS.textMuted, lineHeight: 1.6 }}>
          เล่นแชร์ให้เป็น เล่นแชร์ให้ปลอดภัย — รวมทุกอย่างที่ควรรู้ก่อนเข้าวง ตั้งแต่วิธีคิดดอก กฎหมาย จนถึงสัญญาณอันตราย
        </div>

        {/* Highlights */}
        <div style={{ padding: '12px 20px 6px', fontSize: 13, fontWeight: 700 }}>ไฮไลต์น่ารู้</div>
        <div style={{ display: 'flex', gap: 12, overflowX: 'auto', padding: '0 16px 10px' }}>
          {HIGHLIGHTS.map(h => {
            const t = HL_TONE[h.tone] || HL_TONE.ink;
            return (
              <div key={h.id} data-testid={`learn-highlight-${h.id}`} onClick={() => nav(`/app/learn/${h.id}`)} className="ps-press"
                style={{ flexShrink: 0, width: 210, background: t.bg, color: t.fg, borderRadius: 16, padding: 16, position: 'relative', overflow: 'hidden' }}>
                <div style={{ fontSize: 10, color: t.tag, letterSpacing: 1, textTransform: 'uppercase', fontWeight: 600 }}>{h.tag}</div>
                <div style={{ fontSize: 16, fontWeight: 700, marginTop: 8, letterSpacing: -0.3, lineHeight: 1.25 }}>{h.title}</div>
                <div style={{ fontSize: 11.5, color: t.tag, marginTop: 8, lineHeight: 1.4 }}>{h.sub}</div>
                <Icon.chevronR size={16} stroke={t.fg} style={{ position: 'absolute', bottom: 14, right: 14 }} />
                <div style={{ position: 'absolute', right: -18, top: -18, width: 70, height: 70, border: `1px solid ${t.tag}`, opacity: 0.3, transform: 'rotate(45deg)' }} />
              </div>
            );
          })}
        </div>

        {/* All articles */}
        <div style={{ padding: '14px 20px 6px', fontSize: 13, fontWeight: 700 }}>หัวข้อทั้งหมด</div>
        <div style={{ margin: '0 16px', background: PS.surface, border: `1px solid ${PS.line}`, borderRadius: 18, overflow: 'hidden' }}>
          {ARTICLES.map((a, i) => {
            const IcoC = Icon[a.icon] || Icon.info;
            return (
              <div key={a.id} data-testid={`learn-article-${a.id}`} onClick={() => nav(`/app/learn/${a.id}`)} className="ps-press"
                style={{ display: 'flex', gap: 12, alignItems: 'center', padding: '13px 14px', borderBottom: i < ARTICLES.length - 1 ? `1px solid ${PS.lineSoft}` : 'none' }}>
                <div style={{ width: 38, height: 38, borderRadius: 11, background: PS.panel, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><IcoC size={18} stroke={PS.ink} /></div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 13.5, fontWeight: 600 }}>{a.title}</div>
                  <div style={{ fontSize: 11, color: PS.textMuted, marginTop: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{a.subtitle}</div>
                </div>
                <Icon.chevronR size={16} stroke={PS.textDim} />
              </div>
            );
          })}
        </div>
      </div>
    </Screen>
  );
}
